var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orbits"},_vm._l((_vm.count),function(index){return _c('div',{key:index,style:(_vm.getStyle(index - 1))})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }